import React, {useEffect, useState} from 'react';
import {DialogMUI, LoaderMUI} from '../../../shared';
import {ReactComponent as CloseSvg} from '../../../assets/icons/close.svg';
import ImageZoom from 'react-image-zooom';
import {useDispatch, useSelector} from "react-redux";
import {POPUPS} from "../../../redux/actions/app/appActionTypes";
import {getChatMessage} from "../../../redux/actions/projects/projectsActions";
import {closeModal} from "../../../redux/actions/app/appActions";
import {useTranslation} from "react-i18next";

const ImagesChatPopup = () => {
    const {t} = useTranslation();
    const [imageUrl, setImageUrl] = useState('')
    const dispatch = useDispatch();
    const popupShow = useSelector(({app}) => app.popupToShow);
    const popupData = useSelector(({app}) => app.popupToShowData);

    const visible = popupShow === POPUPS.PHOTO_PREVIEW;

    const onCloseHandler = () => {
        if (imageUrl) {
            URL.revokeObjectURL(imageUrl);
        }
        setImageUrl('');
        dispatch(closeModal());
    };


    useEffect(() => {
        const fetchImage = async () => {
            if (popupData?.projectId && popupData.chatId && popupData.id) {
                try {
                    const res = await dispatch(getChatMessage(popupData?.projectId, popupData.chatId, popupData.id));
                    const image = res?.payload?.data?.data?.files[popupData?.indexPhoto].path;
                    const response = await fetch(image);

                    const blob = await response.blob();
                    const objectURL = URL.createObjectURL(blob);

                    setImageUrl(objectURL);
                } catch (e) {
                    onCloseHandler();
                }
            } else {
                onCloseHandler();
            }
        };

        if (visible && popupData && Object.keys(popupData)?.length > 0) {
            fetchImage();
        } else {
            onCloseHandler();
        }
    }, [visible]);

    return (
        <DialogMUI
            open={visible}
            withoutDefaultWrapper={true}
            className={'mui-withoutBg'}
            fullScreen={true}
            maxWidth={'lg'}
        >
            {visible && (
                <>
                    {imageUrl ? <div className='dialog-mui__wrapper'>
                        <div
                            className='dialog-mui__close'
                            onClick={onCloseHandler}
                        >
                            <CloseSvg/>
                        </div>

                        <div className='dialog-mui__image image-chat-x'>
                            <div className="image_download">
                                <a href={imageUrl} download={`${popupData?.name || 'download'}`}>
                                    {t('ProjectsReports.common.Download')}
                                </a>
                            </div>
                            <ImageZoom className={'imageZoom-img'} src={imageUrl} alt={'image chat'} zoom='200'/>
                        </div>
                    </div> : <LoaderMUI noBg={true} staticPos={true}
                                        circleSize={40}/>}
                </>

            )}
        </DialogMUI>
    );
};

export default ImagesChatPopup;
